import { faSortDown, faSortUp, faSort } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const CustomSortIcon = (options: any) => {
	const icon = options.sorted ? (options.sortOrder < 0 ? faSortDown : faSortUp) : faSort;
	return <FontAwesomeIcon icon={icon} className="pl-3 text-gray-200" />;
};
